// extracted by mini-css-extract-plugin
export default {"familyHistoryForm":"FamilyHistory_familyHistoryForm__xTM+H","fieldLabel":"FamilyHistory_fieldLabel__S5nmt","requiredMark":"FamilyHistory_requiredMark__IxAP8"};